export default __webpack_public_path__ + "static/media/selecting_the_indicators_1.f3bc0282.png";